import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Conf from '../router/Conf'
import user from './modules/user'
//安装插件
Vue.use(Vuex)
import {chkAppVersion} from '../utils/upgrade.js'
import {Toast} from 'vant'
//创建对象
 export default new Vuex.Store({
   modules: {
     common:user,
   }
 })
//const store = new Vuex.Store({
//})
//export default store
var _first_back = null;
document.addEventListener('plusready', function () {
  var webview = plus.webview.currentWebview();
  plus.key.addEventListener('backbutton', function () {
    webview.canBack(function (e) {
      if (e.canBack) {
        webview.back();
      } else {
        if (!_first_back) {
          _first_back = new Date().getTime();
          Toast({
            message: '再按一次退出应用！'
          });
          setTimeout(function () {
            _first_back = null;
          }, 1000);
        } else {
          if (new Date().getTime() - _first_back < 1000) {
            plus.runtime.quit();
          }
        }
      }
    })
  });

  chkAppVersion(false);
});


if(!localStorage.getItem("area_districts")){
	axios.get("https://restapi.amap.com/v3/config/district?keywords=%E4%B8%AD%E5%9B%BD&subdistrict=3&key="+Conf.amapWebServerKey)
	.then(response => {
		if(response.data.info=="OK"){
			var compare = function(attr){
				return function(a,b){
					return a[attr]-b[attr];
				}
			}
			var getChilds = function(dists){
				let arr = [];
				for(var i in dists){
					let o = {'adcode':dists[i]['adcode'],'text':dists[i]['name']};
					if(dists[i]['districts'].length > 0){
						o['children'] = getChilds(dists[i]['districts']);
					}
					arr.push(o);
				}
				return arr.sort(compare('adcode'))
			}
			localStorage.setItem("area_districts", JSON.stringify(getChilds(response.data.districts[0].districts)));
		}
	})
	.catch(error => {});
}




// WEBPACK FOOTER //
// ./src/store/index.js